<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.667969 8.00065C0.667969 5.42332 2.75731 3.33398 5.33464 3.33398H10.668C13.2453 3.33398 15.3346 5.42332 15.3346 8.00065C15.3346 10.578 13.2453 12.6673 10.668 12.6673H5.33464C2.75731 12.6673 0.667969 10.578 0.667969 8.00065ZM5.33464 4.66732C3.49369 4.66732 2.0013 6.1597 2.0013 8.00065C2.0013 9.8416 3.49369 11.334 5.33464 11.334H10.668C12.5089 11.334 14.0013 9.8416 14.0013 8.00065C14.0013 6.1597 12.5089 4.66732 10.668 4.66732H5.33464ZM5.33464 7.00065C4.78235 7.00065 4.33464 7.44837 4.33464 8.00065C4.33464 8.55294 4.78235 9.00065 5.33464 9.00065C5.88692 9.00065 6.33464 8.55294 6.33464 8.00065C6.33464 7.44837 5.88692 7.00065 5.33464 7.00065ZM3.0013 8.00065C3.0013 6.71199 4.04597 5.66732 5.33464 5.66732C6.6233 5.66732 7.66797 6.71199 7.66797 8.00065C7.66797 9.28932 6.6233 10.334 5.33464 10.334C4.04597 10.334 3.0013 9.28932 3.0013 8.00065Z"
      fill="#191414"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg {
  width: 100%;
  height: 100%;
}
</style>
